import React, { JSX } from "react";

import { FieldsManagement } from "./fields_management";
import { FrequencySelector } from "./frequency_selector";

export const FieldsTab = (): JSX.Element => (
  <>
    <FrequencySelector />
    <FieldsManagement />
  </>
);
